import { createStore } from '../.'

import type { StateStorage } from 'zustand/middleware'

interface SwapSlippageStore {
  slippage: number
  setSlippage: (slippage: number) => void
}

export const createSwapSlippageStore = (storage: StateStorage) =>
  createStore<SwapSlippageStore>(
    storage,
    (set) => ({
      slippage: 2,
      setSlippage(slippage) {
        set({ slippage })
      },
    }),
    {
      persist: {
        name: 'swalSlippage',
        version: 0,
      },
    }
  )
